export const selectTracking = (state) => state['casino/tracking'];
